import gql from 'graphql-tag'

export default gql`
mutation exportAllRunnerCount($types : String){
  exportAllRunnerCount(types : $types){
    url
    fileName
  }
}
`